<script lang="ts" setup>
import {
  PCard,
  PCardSize,
  PIcon,
  PPageContainer,
  PSpace,
  PSpaceSize,
  PTextBody1,
} from '@previo/design-system'
import { Color } from '@previo/codebooks'
import { usePropertyStore } from '~/store/property/property'

const propertyStore = usePropertyStore()
</script>

<template>
  <p-page-container>
    <p-space :mobile="PSpaceSize.XL" vertical />
    <p-card class="p-flex p-justify-center" :pa-mobile="PCardSize.MD">
      <p-icon icon="triangle-exclamation" :color="Color.NEGATIVE" />
      <p-space :mobile="PSpaceSize.XS" />
      <p-text-body1
        :text="
          $t('Access to property #{id} is not available due to an invalid or missing license.', {
            id: propertyStore.property.propertyId,
          })
        "
      />
    </p-card>
  </p-page-container>
</template>
